import { CONTENT_TYPE } from '../data-model/constants';

/**
 * Flattens a `suggestedQuestions` response into the shape `BannerBody` renders.
 *
 * Questions keep the order the API returned them in.
 *
 * The API nests per anchor, then per stack, then per strategy group, and returns an empty `stacks`
 * list when it has nothing for the search term, so every level is optional.
 *
 * @param {object} data - Raw `useDataModel` data.
 * @param {string} anchor - Search term the questions were requested for.
 * @returns {{
 *   questions: Array<{text: string, position: number}>,
 *   summary: ?{type: string, title: ?string, body: ?string}
 * }}
 */
export const toBannerContent = (data, anchor) => {
  const results = data?.suggestedQuestions?.results || [];
  const result = results.find((entry) => entry?.anchor?.value === anchor) || results[0];
  const strategyGroups = (result?.stacks || [])
    .flatMap((stack) => stack?.strategyGroups || []);

  const questions = strategyGroups
    .flatMap((group) => group?.strategies || [])
    .flatMap((strategy) => strategy?.questions || [])
    .map((question) => question?.question)
    .filter(Boolean)
    .map((text, index) => ({ text, position: index }));

  const summary = strategyGroups
    .flatMap((group) => group?.summaries || [])
    .find((entry) => entry?.type === CONTENT_TYPE.SUMMARY && !!(entry.title || entry.body));

  return {
    questions,
    summary: summary || null
  };
};
